// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uy-0";
export var checkoutRateBadgeLink = "_uy-1";